import React from 'react';
import { Link } from 'react-router-dom';
import PageSeo from '../components/PageSeo';
import PocketBillingAiDownloadLinksSection from '../components/PocketBillingAiDownloadLinksSection';
import { DOWNLOAD_LINK_LIST } from '../config/pocketBillingAiDownloadLinks';
import { absoluteUrl } from '../seo/siteConfig';

const downloadSeo = {
  title: 'Download PocketBillingAI — Mac, Windows & Android | RestroAI',
  description:
    'Download PocketBillingAI v1.9.8 for Mac (Intel & Apple Silicon), Windows PC, and Android on Google Play.',
  canonical: absoluteUrl('/pocketbillingai/download'),
};

export default function PocketBillingAiDownloadPage() {
  return (
    <div className="min-h-screen bg-stone-50 text-stone-900">
      <PageSeo {...downloadSeo} />
      <header className="border-b border-stone-200 bg-white/80 backdrop-blur-sm sticky top-0 z-10">
        <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between gap-3">
          <Link to="/pocketbillingai" className="text-sm text-indigo-600 hover:text-indigo-800 font-medium">
            ← Back to PocketBillingAI
          </Link>
          <img src="/pocketbillingai-logo.png" alt="Pocket Billing AI" className="h-10 w-10 object-contain" />
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-3 sm:px-6 py-10 sm:py-16">
        <header className="text-center max-w-3xl mx-auto mb-10 sm:mb-14">
          <p className="text-indigo-600 text-sm font-semibold uppercase tracking-wide mb-2">Download</p>
          <h1 className="text-3xl sm:text-5xl font-bold text-stone-900 mb-4">Get PocketBillingAI</h1>
          <p className="text-stone-600 text-base sm:text-lg leading-relaxed">
            Choose the installer for your device. Offline-first billing for kirana shops and retail — GST reports, AI
            speech billing, udhar khata, and sync between Android and your counter PC.
          </p>
        </header>

        <PocketBillingAiDownloadLinksSection showViewAll={false} />

        <section className="mt-14 sm:mt-16 max-w-3xl mx-auto">
          <h2 className="text-xl font-bold text-stone-900 mb-4">After you install</h2>
          <ol className="list-decimal pl-5 space-y-3 text-stone-700 text-sm sm:text-base">
            <li>Open PocketBillingAI on your Mac, Windows PC, or Android phone.</li>
            <li>Sign in with the mobile number registered when you started your trial or subscription.</li>
            <li>Optional: use the Sync tab to back up with Google Drive between devices.</li>
            <li>
              New shop?{' '}
              <a href="/pocketbillingai#contact" className="text-indigo-600 hover:underline">
                Request a free trial
              </a>
              .
            </li>
          </ol>
        </section>

        <section className="mt-10 rounded-2xl border border-stone-200 bg-white p-6 sm:p-8">
          <h2 className="text-lg font-semibold text-stone-900 mb-4">Which Mac download should I use?</h2>
          <ul className="space-y-3 text-sm sm:text-base text-stone-700">
            <li>
              <strong>Apple Silicon:</strong>{' '}
              <a
                href={DOWNLOAD_LINK_LIST[0].href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-indigo-600 hover:underline"
              >
                Silicon DMG
              </a>
            </li>
            <li>
              <strong>Intel Mac:</strong>{' '}
              <a
                href={DOWNLOAD_LINK_LIST[1].href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-indigo-600 hover:underline"
              >
                Intel DMG
              </a>
            </li>
          </ul>
        </section>
      </main>
    </div>
  );
}
